import type { ReactNode } from 'react'

import { PageBackButton } from '@/components/common/PageBackButton'

interface ListPageHeaderProps {
    icon?: ReactNode
    title: string
    /**
     * Màn nào đã có logic quay lại riêng thì truyền vào; bỏ trống thì nút lùi
     * một bước lịch sử trình duyệt.
     */
    onBack?: () => void
    subtitle?: string
    utilityActions?: ReactNode
    primaryActions?: ReactNode
}

export function ListPageHeader({
    icon,
    title,
    onBack,
    subtitle,
    utilityActions,
    primaryActions,
}: ListPageHeaderProps) {
    return (
        <div
            data-testid="list-page-header"
            className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between"
        >
            <div className="flex min-w-0 items-start gap-2">
                {/* Ghì chiều cao nút về đúng 1 dòng tiêu đề để hàng header
                    không bị đội cao thêm so với trước khi có nút quay lại. */}
                <PageBackButton onBack={onBack} className="-my-2 md:-my-1" />
                {icon}
                <div className="min-w-0">
                    <h1 className="text-xl font-semibold">{title}</h1>
                    {subtitle && (
                        <p className="text-sm text-muted-foreground">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
            {(utilityActions || primaryActions) && (
                <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
                    {utilityActions && (
                        <div
                            data-testid="list-page-utility-actions"
                            className="flex flex-wrap items-center gap-2"
                        >
                            {utilityActions}
                        </div>
                    )}
                    {primaryActions && (
                        <div
                            data-testid="list-page-primary-actions"
                            className="grid w-full grid-cols-1 gap-2 min-[420px]:grid-cols-2 sm:flex sm:w-auto sm:items-center"
                        >
                            {primaryActions}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
